
import styled from './Home.module.css';
import Logotype from '../Logotype/Logotype';
import Footer from '../Footer/Footer';
import Nav from '../Nav/Nav';
import Title from '../Title/Title';
import QuienesSomos from '../QuienesSomos/QuienesSomos';
import { Link, useLocation } from 'react-router-dom';

const Home = () => {

    const location = useLocation();



    return (

        <div className={styled.container}>


            <div className={styled.containerHead}>
                <Link to='/'>
                    <Logotype />
                </Link>
                <Title />

            </div>

            <div className={styled.bodyContainer}>

                <Nav />
                {location.pathname === '/quienes-somos' && <QuienesSomos />}

            </div>
            <Footer />

        </div>

    )


}


export default Home;